import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as iconStyles from '../../styles/icons.css';
import * as buttonStyles from '../../styles/buttons.css';

const ResetButton = ({ onClick }) => (
  <button className={buttonStyles.buttonSolid} onClick={onClick}>
    <div className={buttonStyles.iconContainer}>
      <i className={iconStyles.iconNew} />
      <span>Start Over</span>
    </div>
  </button>
);

ResetButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const mapDispatchToProps = () => ({
  onClick: () => {
    window.location.href = '/statedata/custom/'; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
  },
});

export default connect(undefined, mapDispatchToProps)(ResetButton);

export { ResetButton, mapDispatchToProps };



// WEBPACK FOOTER //
// ./app/components/resetBtn/index.js